import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Checkliste } from '@softapps/core/checklist';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_CHECKLISTEN } from '@softapps/core/checklist';
import { ChecklistenStore } from '@softapps/core/checklist';

export const checklistenResolver: ResolveFn<Checkliste[] | null> = async () => {
  const store = inject(Store);

  try {
    return await store.dispatch(
      SOFTLINE_FEATURE_CHECKLISTEN,
      ChecklistenStore.actions.loadManyOnce
    );
  } catch {
    return null;
  }
};
